﻿export interface IEmailEntityModel {
    emailTagIndex: number;
    emailEntityId: number;
    emailFamilyValue: number;
    emailFamilyString: string;
    emailTypeValue: number;
    emailTypeString: string;
    emailExcelValue: number;
    emailExcelString: string;
}

export interface IEmailSendeeModel {
    emailSendeeIndex: number;
    emailSendeeId: number;
    emailAddressFieldValue: number;
    emailAddressFieldString: string;
    contactEntityTypeValue: number;
    contactEntityTypeString: string;
    centerTypeValue: number;
    centerTypeString: string;
    contactPositionIdValue: number;
    contactPositionIdString: string;
}
